import {pull, values} from 'lodash';
import moment from 'moment';
import {getI18n} from 'react-i18next';

import {Language, DEFAULT_LANGUAGE} from 'constants/language';

import {setItem, getItem} from './Storage';

const STORAGE_KEY = 'vs-lang';

export class LanguageService {
    static subs = [];

    static getStorageLanguage = (): Language => getItem(STORAGE_KEY) as Language;

    static isStorageLanguageValid = (): boolean => LanguageService.isValidLanguage(LanguageService.getStorageLanguage());

    static getLanguage = (): Language => {
        const language = LanguageService.getStorageLanguage();
        return LanguageService.isValidLanguage(language) ? language : DEFAULT_LANGUAGE;
    };

    static setLanguage = (language: Language) => {
        const previous: string = LanguageService.getLanguage();
        if (LanguageService.isValidLanguage(language)) {
            if (previous !== language) {
                getI18n().changeLanguage(language);
                setItem(STORAGE_KEY, language);
                LanguageService.notifyListeners(language);
            }
            if (moment.locale() !== language) {
                moment.locale(language);
            }
        }
    };

    static isValidLanguage = (language: Language): boolean => values(Language).includes(language);

    static subscribeLanguageChange = (callback: (language: Language) => void): () => void => {
        LanguageService.subs.push(callback);
        return () => {
            pull(LanguageService.subs, callback);
        };
    };

    static notifyListeners = (language: Language): void => {
        LanguageService.subs.forEach((s) => s(language));
    };
}
